import { DialogActions, Button, CircularProgress } from "@mui/material";
import "../../../assets/styles/modals.css";

export const ModalFooter = (props:any) => {

  const { 
    confirmText, onConfirm, cancelText, onCancel, cancelColor, confirmColor, className, backgroundColor, buttonType, secondaryText, onSecondaryConfirm, clearState, loadingConfirmText, disabledConfirmText
  } = props;

    return (
      <DialogActions
        className={className || "modal-footer"}
        sx={{ position: "sticky", gap: 1, px: 3, py: 2 }}
      >
        {
          cancelText && (
            <Button onClick={()=>{onCancel && onCancel(); clearState && clearState()}} size="small" color={cancelColor || "primary"} variant="outlined" className={backgroundColor || ''}>
              {cancelText}
            </Button>
          )
        }
        {
          confirmText && (
            <Button onClick={onConfirm} disabled={loadingConfirmText || disabledConfirmText} type={buttonType} size="small" color={confirmColor || "primary"} variant="contained">
              {confirmText}
              {
                loadingConfirmText && (
                  <CircularProgress color="inherit" size={12} sx={{ ml: 1 }} />
                )
              }
            </Button>
          )
        }
        {
          secondaryText && (
            <Button onClick={onSecondaryConfirm} type={buttonType} size="small" color="error" variant="outlined">
              {secondaryText}
            </Button>
          )
        }
      </DialogActions>
    )
}
